import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import {
  Accordion,
  AccordionDetails,
  Box,
  Grid,
  CircularProgress,
  Backdrop,
  Typography,
  Divider,
  Paper,
} from "@mui/material";
import moment from "moment";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import { moneyformatter } from "src/common/utils/helpers";
import CommonButtonDefault from "src/components/CommonButton/CommonButtonDefault";
import Heading from "./Heading";
import { useStyles } from "./styles";

type Props = {
  expand: boolean;
  updateExpandStatus: (type: number) => void;
};

export function Crew({ expand, updateExpandStatus }: Props): React.ReactElement {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [loader, setLoader] = useState(false);
  const [crewDetails, setCrewDetails] = useState<any>([]);
  const { crewId } = useParams<{ crewId: any }>();

  const getIVRData = async () => {
    try {
      setLoader(true);
      const results = await fetchWrapper.get(`get-order-crew-detail-by-crew-id/${crewId}`);
      setCrewDetails(results?.crewDetails);
      return setLoader(false);
    } catch (error: any) {
      setLoader(false);
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    }
  };

  React.useEffect(() => {
    if (expand) {
      getIVRData();
    }
  }, [expand]);
  return (
    <>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box border={1} mb={2} borderColor="grey.200">
        <Accordion square elevation={0} expanded={expand} onChange={() => updateExpandStatus(3)}>
          <Heading heading="Crew" />
          <Box borderTop={1} mb={1} borderColor="grey.200"></Box>
          <AccordionDetails>
            <Paper elevation={0} square className={classes.root}>
              <Box p={1}>
                {crewDetails.map((crewDetail: any, index: any) => (
                  <Box mt={2} key={index}>
                    <Grid item xs={12} md={12}>
                      <Grid container direction="row">
                        <Grid item xs={12} md={12} className={classes.oddRow}>
                          <Box pl={1} pr={1} my={1}>
                            <Grid container direction="row">
                              <Grid item xs={12} md={12}>
                                <Grid container direction="row">
                                  <Grid item xs={12} md={5}>
                                    <Grid container direction="row">
                                      <Grid item xs={12} md={3}>
                                        <Box color="text.secondary">
                                          <Typography>Visit Date:</Typography>
                                        </Box>
                                      </Grid>
                                      <Grid item xs={12} md={9}>
                                        <Box color="text.primary">
                                          <Typography>
                                            {moment(crewDetail.visitDate).format(
                                              "MM/DD/YYYY hh:mm A"
                                            )}
                                          </Typography>
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={12} md={4}>
                                    <Grid container direction="row">
                                      <Grid item xs={12} md={3}>
                                        <Box color="text.secondary">
                                          <Typography>Status:</Typography>
                                        </Box>
                                      </Grid>
                                      <Grid item xs={12} md={9}>
                                        <Box color="text.primary">
                                          <Typography>{crewDetail.status}</Typography>
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={12} md={3}>
                                    <Grid container direction="row">
                                      <Grid item xs={12} md={3}>
                                        <Box color="text.secondary">
                                          <Typography>NTE:</Typography>
                                        </Box>
                                      </Grid>
                                      <Grid item xs={12} md={9}>
                                        <Box color="text.primary">
                                          <Typography>
                                            {moneyformatter(crewDetail.nte, true)}
                                          </Typography>
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                              {/* <Grid item xs={12} md={3}>
                      <Box textAlign="right">
                        <Box component="span" mr={1}>
                          <CommonButtonDefault
                            onClick={() => {
                              // printWO(crewDetail.orderCrewDetailId);
                              console.log("");
                            }}
                          >
                            Print WO
                          </CommonButtonDefault>
                        </Box>
                        <Box component="span" mr={1}>
                          <CommonButtonDefault
                            onClick={() => {
                              // auditCrewDispatch(crewDetail.orderCrewDetailId);
                              console.log("");
                            }}
                          >
                            Audit
                          </CommonButtonDefault>
                        </Box>
                        <Box component="span" mr={1}>
                          <CommonButtonDefault
                            onClick={() => {
                              // editCrewDispatch(item, crewDetail);
                              console.log("");
                            }}
                          >
                            Edit
                          </CommonButtonDefault>
                        </Box>
                      </Box>
                    </Grid> */}
                            </Grid>
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Divider />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                ))}
              </Box>
            </Paper>
          </AccordionDetails>
        </Accordion>
      </Box>
    </>
  );
}
